import React from "react";
import { Link } from "react-router-dom";
import { useSubscription } from "../hooks/useSubscription";

export default function SubscriptionBanner() {
  const { data, loading } = useSubscription();
  if (loading || !data?.subscription) return null;

  const sub = data.subscription;
  const access = data.access;

  if (sub.status === "trialing" && sub.trial_days_remaining != null) {
    const days = sub.trial_days_remaining;
    return (
      <div className={`saas-banner${days <= 3 ? " saas-banner--warn" : ""}`}>
        <span>
          Free trial: <strong>{days} day{days === 1 ? "" : "s"}</strong> remaining
          {sub.trial_ends_at ? ` (ends ${new Date(sub.trial_ends_at).toLocaleDateString("en-IN")})` : ""}
        </span>
        <Link to="/saas/subscription">Upgrade now</Link>
      </div>
    );
  }

  if (access && !access.allowed) {
    return (
      <div className="saas-banner saas-banner--danger">
        <span>Your subscription has expired. Upgrade to restore full access.</span>
        <Link to="/saas/subscription">Subscribe</Link>
      </div>
    );
  }

  return null;
}
